import React from 'react';

function formatAmount(value) {
  return Number(value).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

// Valor vendido como veio do inclient: o local, na moeda da venda, em destaque, e o
// USD logo abaixo. Um campo só na conferência — o USD acompanha o local.
export default function SoldValue({ amount, currency, mainAmount }) {
  if (amount === null || amount === undefined) return null;

  return (
    <span style={{ display: 'inline-flex', flexDirection: 'column', verticalAlign: 'top' }}>
      <span style={{ fontWeight: 500 }}>
        {currency ? `${currency} ` : ''}
        {formatAmount(amount)}
      </span>
      {mainAmount !== null && mainAmount !== undefined && (
        <span className="secondary-text" style={{ fontSize: '0.85em' }}>
          USD {formatAmount(mainAmount)}
        </span>
      )}
    </span>
  );
}
